import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  article: {
    clear: 'both',
    marginBottom: '24px',
    paddingBottom: '24px',
    borderBottom: '1px solid #ccc',
    overflow: 'hidden',
  },
  leftCol: {
    float: 'left',
    width: '300px',
  },
  rightCol: {
    paddingLeft: '324px',
  },
  chip: {
    margin: '0 0 5px 5px',
    height: '32px',
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    borderRadius: '16px',
    backgroundColor: '#ddd',
    color: '#000',
    verticalAlign: 'middle',
    lineHeight: '32px',
    boxSizing: 'border-box',
    padding: '0 10px',
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  title: {
    marginTop: '0',
    color: '#000'
  },
  total: {
    marginBottom: '24px',
    fontWeight: '500',
    fontSize: '1.25rem'
  },
  image: {
    margin: '0 0 5px 5px',
    height: '100px',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  thumbnail: {
    width: '100%',
    display: 'block',
    marginBottom: '5px',
  },
  media: {
    verticalAlign: 'middle'
  },
  loading: {
    textAlign: 'center',
    fontSize: '2rem',
  }
};

const MediaField = ({ classes, record }) => {
  return (<div>
    {record.media.images_count > 0 && <p><span className={classes.media}>Images:</span>{record.media.images.map(img => <img className={classes.image} src={img.url} alt={img.url} key={img.url} />)}</p>}
    {record.media.videos_count > 0 && <p><span className={classes.media}>Videos:</span>{record.media.videos.map(vid => <a rel="noopener noreferrer" href={vid.url} target="_blank" className={classes.chip} key={vid.url}>{vid.url}</a>)}</p>}
    {record.media.facebook_count > 0 && <p><span className={classes.media}>Facebook:</span>{record.media.facebook.map(fb => <a rel="noopener noreferrer" href={fb.url} target="_blank" className={classes.chip} key={fb.url}>{fb.url}</a>)}</p>}
    {record.media.twitter_count > 0 && <p><span className={classes.media}>Twitter:</span>{record.media.twitter.map(tw => <a rel="noopener noreferrer" href={tw.url} target="_blank" className={classes.chip} key={tw.url}>{tw.url}</a>)}</p>}
    {record.media.other_count > 0 && <p><span className={classes.media}>Other:</span>{record.media.other.map(oth => <a rel="noopener noreferrer" href={oth.url} target="_blank" className={classes.chip} key={oth.url}>{oth.url}</a>)}</p>}
    </div>
  );
}

MediaField.propTypes = {
  classes: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
};

export default withStyles(styles)(MediaField);


// WEBPACK FOOTER //
// ./src/resources/ui/MediaField.js